<template>
    <span class="minus-icon">
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line x1="4" y1="9" x2="14" y2="9" :stroke="fill" />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconMinus',
    props: {
        fill: {
            type: String,
            default: '#fff',
        },
    },
};
</script>
